<script>
    import { onMount } from "svelte";
    import { fade } from "svelte/transition";
    import { link, push } from "svelte-spa-router";
    import Loading from "../components/donorflow-ui/Loading.svelte";
    import Question from "../components/Question.svelte";
    import NavTabs from "../components/donorflow-ui/NavTabs.svelte";
    export let params = {};
    let db;
    let quiz = {};
    let questions = [];
    let loading = true;
    let touched = false;

    async function getQuiz(id) {
        db.collection("quizes")
            .doc(id)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    quiz = { id: doc.id, ...doc.data() };
                    console.log(quiz);
                    questions = [...questions, ...quiz.questions];
                    // getQuestions(doc.id);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    async function getQuestions(id) {
        db.collection("quizQuestions")
            .where("quizId", "==", id)
            .orderBy("sortOrder")
            .get()
            .then((docs) => {
                docs.forEach((doc) => {
                    questions = [...questions, { id: doc.id, ...doc.data() }];
                });
            });
    }

    function addQuestion() {
        questions = [
            ...questions,
            {
                text: "Text",
                options: [{ text: "Option 1" }, { text: "Option 2" }],
            },
        ];
    }

    function changeValues(event, i) {
        console.log(event.target.value);
        console.log(i);
        questions[i].text = event.target.value;
        quiz.questions = questions;
        touched = true;
        console.log(quiz);

    }

    function saveChanges(){
        return db.collection('quizes')
          .doc(quiz.id)
          .update(quiz)
          .then(r => { 
              console.log(r);
              touched = false;
          })
          .catch(e => console.log(e));
    }

    onMount(() => {
        db = firebase.firestore();
        getQuiz(params.id).then(() => (loading = false));
    });
</script>

<div style="background: #FFF08E; height: 360px;" />
<div style="margin-top: -300px;" in:fade>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10">
                {#if !loading}
                    <h3>
                        <a href="/" use:link class="df-link-arrow">&larr;</a
                        >{quiz?.name}
                    </h3>
                {/if}
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-10">
                <NavTabs items={[{label: 'Questions', path: '/quiz/'+quiz.id}, {label: 'Preview', path: '/preview/'+quiz.id}]} />
                {#if touched}
                    <div class="savebar" in:fade>
                        <button class="btn-success" on:click="{saveChanges}">Save changes</button>
                    </div>
                {/if}
                <div class="card shadow-sm" style="min-height: 400px;border:none;">
                    <div class="card-body">
                        {#if loading}
                            <div class="text-center">
                                <Loading text="Fetching questions..." />
                            </div>
                        {:else}
                            <div class="questions-area">
                                {#each questions as q, i}
                                    <Question
                                        data={q}
                                        index={i}
                                        {changeValues}
                                    />
                                {/each}
                                <button on:click={addQuestion} class="btn btn-primary shadow-sm"
                                    >+ Add a question</button
                                >
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div style="height:50px;width:100%;"></div>
<style>
    a.df-link-arrow {
        margin-right: 15px;
        color: #242424;
        text-decoration: none;
    }
    .questions-area {
        padding: 20px 30px;
    }
    .savebar {
        text-align: center;
        background: #cee6b4;
        padding: 10px 20px;
    }
</style>
